import { render } from "./SmartboxSection.vue?vue&type=template&id=e5300378"
import script from "./SmartboxSection.vue?vue&type=script&lang=js"
export * from "./SmartboxSection.vue?vue&type=script&lang=js"
script.render = render

export default script